// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"8acd6178","139":"b4b9bc2c","234":"420b1804","447":"6c900ecd","465":"227c6ae1","525":"c315be9f","624":"2249515b","690":"1dd16ede","787":"313df561","805":"d73d5206","972":"9f7218f2"}[chunkId] + ".chunk.js";
};